import isPromise from "is-promise";
import { authenticatedFetch } from "@nutrien/cxp-api-fetch-module";
import dayjs from "dayjs";

const DEBUG = false;

class ApiError extends Error {
  constructor(message: string, status: number | null) {
    super(message);
    this.status = status;
  }

  status: number | null;
}

function log(message: any) {
  if (typeof message === "string") {
    console.log(`${dayjs().format("YYYY-MM-DD HH:mm:ss")} - ORCH - ${message}`);
  } else {
    log("");
    console.log(message); // log complex object on new line so it can be inspected in the console
  }
}

const logDebug = (message?: any, ...optionalParams: any[]) => {
  if (DEBUG) {
    console.log(message, optionalParams);
  }
};

function redirectIfSessionEnded(result: any) {
  if (result.toString().includes("No current user")) {
    if (!window.location.toString().includes("/login")) {
      window.location.assign("/login?sessionEnded");
    }
  }
}

export async function callAPI<T>(
  endpoint: string,
  requestInit: any,
  requiresAuth = true,
  redirectToLoginWhenSessionExpired = true
): Promise<T> {
  try {
    logDebug(endpoint, requestInit);
    if (requiresAuth === undefined) {
      requiresAuth = true;
    }

    const response = requiresAuth
      ? await authenticatedFetch(endpoint, requestInit)
      : await fetch(endpoint, requestInit);

    if (response.headers.has("server-timing")) {
      const timingHeader = response.headers.get("server-timing");
      if (timingHeader) {
        log("server-timing for " + endpoint);
        const timings = timingHeader.split(",");
        timings.forEach(timing => {
          log(timing);
        });
      }
    }

    const data = await response.json();
    logDebug(endpoint, data);
    if (data.success || data.successful || response.ok) {
      return data;
    }
    throw new ApiError(data.errorMessage, response.status);
  } catch (error) {
    logDebug(endpoint, error);

    if (isPromise(error)) {
      const result: any = await error;
      logDebug(endpoint, result);

      if (redirectToLoginWhenSessionExpired) {
        redirectIfSessionEnded(result);
      }

      if ("errorMessage" in result) {
        throw new Error(result.errorMessage);
      }
    }

    if (redirectToLoginWhenSessionExpired) {
      redirectIfSessionEnded(error);
    }

    throw error;
  }
}
